const swea = require('swea');
const InteractionManager = swea.editor.InteractionManager;
const InstructionServiceActions = swea.react.actions.InstructionServiceActions;
const ViewerManager = swea.editor.ViewerManager;

/**
 * A custom implementation of the best camera interaction.
 */
class CustomPerpendicularViewInteraction extends swea.editor.interactions.PerpendicularViewInteraction {
  constructor(options) {
    super(options);
    this._disabledInteractionClasses = [];
  }
  
  whenInitialized(element, viewerId) {
    super.whenInitialized(element, viewerId);
    this._disabledInteractionClasses = InteractionManager.instance().disableContinuousInteractions();
    ViewerManager.instance().getViewerById(viewerId).setCursor('crosshair');
    InstructionServiceActions.showInstruction('instructions.perp_interaction');
  }

  whenTerminated(element, viewerId){
    super.whenTerminated(element, viewerId);
    ViewerManager.instance().getViewerById(viewerId).setCursor('default');
    InteractionManager.instance().enableContinuousInteractions(this._disabledInteractionClasses);
    InstructionServiceActions.showInstruction('instructions.topview');
  }
  
  whenViewed() {
    this.terminate();
  }
  
  whenFailed() {
    InstructionServiceActions.showInstruction('instructions.failed_perp_interaction');
  }
}
export default CustomPerpendicularViewInteraction;
